import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getCategoryListApiCall = createAsyncThunk("CategoryList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: CategoryList } = await API.getCategaryListApi(submitData);

        // console.log("================================================",data);
        

        dispatch(setLoader(false))
        return CategoryList;
    } catch (error) {
        throw error;
    }
});

export const editCategoryDataApiCall = createAsyncThunk("editCategoryData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: editCategoryData, code, message } = await API.updateCategoryApi(submitData);
        if (code === '1') {
            TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editCategoryData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    categoryList: {
        data: [],
        error: null,
    },
    editCategoryData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const CategorySlice = createSlice({
    name: "Category",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCategoryListApiCall.fulfilled, (state, action) => {
                state.categoryList.data = action.payload;
            })
            .addCase(getCategoryListApiCall.rejected, (state, action) => {
                state.categoryList.error = action.error.message;
            })
            .addCase(editCategoryDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editCategoryData.data = data;
                state.editCategoryData.message = message;
                state.editCategoryData.code = code;
            })
            .addCase(editCategoryDataApiCall.rejected, (state, action) => {
                state.editCategoryData.error = action.error.message;
            });
    },
});

export default CategorySlice.reducer;